// try createMirror or mirrorKey

export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';

// export const CREATE_PROJECT = 'CREATE_PROJECT';
// export const LOAD_PROJECTS_SUCCESS = 'LOAD_PROJECTS_SUCCESS';
// export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
// export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
//
//
// export const LOAD_AUTHORS_SUCCESS = 'LOAD_AUTHORS_SUCCESS';
//
//
//
// export const CREATE_GRID = 'CREATE_GRID';
//
// export const LOAD_GRID_SUCCESS = 'LOAD_GRID_SUCCESS';
// export const LOAD_GRID_NAMES_SUCCESS = 'LOAD_GRID_NAMES_SUCCESS';
// export const LOAD_GRID_LAYOUT_SUCCESS = 'LOAD_GRID_LAYOUT_SUCCESS';
// export const LOAD_GRIDS_SUCCESS = 'LOAD_GRIDS_SUCCESS';
// export const CREATE_GRID_SUCCESS = 'CREATE_PROJECT_SUCCESS';
// export const UPDATE_GRID_SUCCESS = 'UPDATE_PROJECT_SUCCESS';




// WEBPACK FOOTER //
// ./src/actions/actionTypes.js